import React, { Component } from 'react'

import { Button, Item, Input, Form, Label } from 'semantic-ui-react'

class CartItem extends Component {
  state = {
    toggleEdit: false,
    qty: this.props.product.qty
  }
  handleChange(e, data) {
    let val = data.value
    if (val > data.max) {
      val = data.max
    }
    this.setState({
      qty: val
    })
  }
  toggleEdit() {
    this.setState({
      toggleEdit: !this.state.toggleEdit,
      qty: this.props.product.qty
    })
  }
  onSubmit(e) {
    e.preventDefault()
    this.props.addToCart(this.props.product.productVariantId, this.state.qty)
    this.setState({ toggleEdit: !this.state.toggleEdit })
  }

  render() {
    const {
      product,
      removeFromCart,
      itemNeedsAttention,
      smallButton
    } = this.props
    const variant = product.v_productVariant
    const { product: baseProduct } = variant
    return (
      <Item>
        <Item.Image src={`/storage/${baseProduct.images[0]}`} size="tiny" />

        <Item.Content>
          <Button
            circular
            basic
            color="grey"
            size="tiny"
            floated="right"
            icon={smallButton ? 'close' : null}
            content={smallButton ? null : 'Remove'}
            onClick={() => removeFromCart(product.id)}
          />
          <Item.Header as="a">
            {baseProduct.name}
          </Item.Header>
          <Item.Meta>
            Size: {variant.size} <br />
            Qty: {product.qty} <br />
            Limit: {variant.virtuallimit}
          </Item.Meta>
          <Item.Description />
          <Item.Extra>
            <Form onSubmit={this.onSubmit.bind(this)}>
              {!itemNeedsAttention
                ? this.state.toggleEdit
                  ? <Input
                      type="number"
                      max={variant.virtuallimit}
                      min={0}
                      placeholder="Qty"
                      value={this.state.qty}
                      action
                      size="small"
                      onChange={this.handleChange.bind(this)}
                    >
                      <input />
                      <Button type="submit" onClick={this.onSubmit.bind(this)}>
                        Edit
                      </Button>
                    </Input>
                  : <a onClick={this.toggleEdit.bind(this)}>Edit Qty</a>
                : <Label size="small" basic color="orange">
                    Item No Longer In Stock
                  </Label>}
            </Form>
          </Item.Extra>
        </Item.Content>
      </Item>
    )
  }
}

export default CartItem



// WEBPACK FOOTER //
// ./src/components/CartItem.jsx